import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { AuthService, BaseSiteService, OccEndpointsService, UserIdService } from '@spartacus/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, publishReplay, refCount, take } from 'rxjs/operators';
import { ShimanoLanguageService } from '../language/shimano-language.service';

@Injectable({
  providedIn: 'root',
})
export class DiscountsService {
  headers = new HttpHeaders().set('Content-Type', 'application/json');
  userCurrent$: Observable<string> = this.userIdService.getUserId();
  shimanoDiscountBucketDetails$ = new BehaviorSubject<any>(null);
  cacheWindowTime = 3600000;

  private cachedDiscountBuckets$: any = {};
  private cachedDiscountBucketDetails$: any = {};

  constructor(
    protected http: HttpClient,
    protected auth: AuthService,
    protected baseService: BaseSiteService,
    protected meta: Meta,
    protected languageService: ShimanoLanguageService,
    protected occEndpointsService: OccEndpointsService,
    private userIdService: UserIdService
  ) {}

  get userCurrent(): string {
    let userCurrent: string;
    this.userCurrent$.pipe(take(1)).subscribe((userId) => (userCurrent = userId));
    return userCurrent;
  }

  get activeLanguage(): string {
    let activeLanguage = '';
    this.languageService.getActive().subscribe((lang) => (activeLanguage = lang));
    return activeLanguage;
  }

  getShimanoDiscountBuckets(): Observable<any> {
    const idString = this.activeLanguage;
    const httpOptions = {
      headers: this.headers,
    };

    if (!this.cachedDiscountBuckets$[idString]) {
      this.cachedDiscountBuckets$[idString] = this.http
        .get(this.occEndpointsService.buildUrl(`/users/${this.userCurrent}/management/discount/buckets`), httpOptions)
        .pipe(publishReplay(1, this.cacheWindowTime), refCount(), take(1), catchError(this.errorHandl));
    }
    return this.cachedDiscountBuckets$[idString];
  }

  getShimanoDiscountBucketDetails(bucketType: string, lang = this.activeLanguage): Observable<any> {
    const idString = [bucketType.toString(), lang].join();
    let httpParams = new HttpParams();
    httpParams = httpParams.append('code', bucketType);

    const httpOptions = {
      headers: this.headers,
      params: httpParams,
    };

    if (!this.cachedDiscountBucketDetails$[idString]) {
      this.cachedDiscountBucketDetails$[idString] = this.http
        .get(
          this.occEndpointsService.buildUrl(`/users/${this.userCurrent}/management/discount/bucket/bucketType`),
          httpOptions
        )
        .pipe(publishReplay(1, this.cacheWindowTime), refCount(), take(1), catchError(this.errorHandl));
    }
    return this.cachedDiscountBucketDetails$[idString];
  }

  errorHandl(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}
